import { createSlice } from '@reduxjs/toolkit'

const initialLayoutState = {
    sidebar: false,
    theme:null
}

export const layoutSlice = createSlice({
    name: 'sidebar',
    initialState: initialLayoutState,
    reducers: {
        toggleSidebarState: (state, action) => {
            const { openSideBar } = action.payload
            state.sidebar = openSideBar
        },
        applicationTheme:(state,action)=>{
            const {theme}= action.payload
            state.theme=theme
        }

    },
})
export const { toggleSidebarState,applicationTheme } = layoutSlice.actions
export default layoutSlice.reducer
